export default __webpack_public_path__ + "static/media/rain-1-day.7e8e4b5c.svg";